import React, { useState } from "react";
import { FaWhatsapp } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const HeroSection = () => {
    const navigate = useNavigate();
    const [email, setEmail] = useState();
    const [phone, setPhone] = useState();
     const url = process.env.REACT_APP_LINK;


    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response=await fetch(`${url}/registeruser/api/hero`,{
                method:"POST",
                headers:{
                    "Content-Type":"application/json"
                },
                body:JSON.stringify({
                    name:email,
                    phone:phone
                })
            })
            const res=await response.json();
            toast("Sent successfully")
        } catch (error) {
            console.log(error)
        }
    }

    return (
        <div className="relative w-full min-h-screen bg-black text-white">

            {/* Background Image */}
            <div
                className="absolute inset-0 bg-cover bg-center"
                style={{
                    backgroundImage:
                        "url('https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTmBKtfzTayLYTZRKkxCnsFx4rSxBiAauNy9A&s')",
                }}
            />

            {/* Overlay */}
            <div className="absolute inset-0 bg-black/70"></div>

            {/* Content */}
            <div className="relative z-10 container mx-auto px-6 py-16 flex flex-col lg:flex-row items-center justify-between gap-10">

                {/* LEFT CONTENT */}
                <div className="max-w-2xl">

                    <span className="inline-block px-4 py-2 bg-green-900/50 border border-green-500 text-green-400 rounded-md mb-6">
                        SMART ECOMMERCE PLATFORM
                    </span>

                    <h1 className="text-4xl md:text-6xl font-bold leading-tight">
                        End-to-End{" "}
                        <span className="text-yellow-400">Ecommerce Business</span>{" "}
                        Growth Solutions
                    </h1>

                    <p className="mt-6 text-gray-300 text-lg">
                        We empower sellers, brands, and distributors with a complete digital commerce ecosystem to grow, manage, and scale their business online across India.
                    </p>

                    <div className="flex flex-wrap gap-4 mt-8">
                        <button onClick={() => navigate("/login")} className="px-6 py-3 bg-white text-black rounded-lg font-semibold hover:bg-gray-200">
                            LOGIN
                        </button>

                        <a
                            href="https://wa.me/918433803555"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <button className="flex items-center gap-2 px-6 py-3 bg-green-600 rounded-lg font-semibold hover:bg-green-700">
                                <FaWhatsapp /> Chat on WhatsApp
                            </button>
                        </a>
                    </div>

                    {/* <div className="flex gap-6 mt-8 text-sm text-gray-300">
            <span>✔ Pan India Service</span>
            <span>✔ Factory Prices</span>
            <span>✔ 10+ Years Exp.</span>
          </div> */}
                </div>

                {/* RIGHT FORM */}
                <div className="w-full max-w-md bg-white/10 backdrop-blur-lg border border-white/20 rounded-2xl p-6 shadow-lg">

                    <h2 className="text-2xl font-bold text-center">Get A Free Quote</h2>
                    <p className="text-center text-gray-300 mb-6">
                        Fill the form to get a callback from our team.
                    </p>

                    <form className="space-y-4" onSubmit={handleSubmit}>

                        <input
                            type="text"
                            placeholder="Your Name"
                            value={email}
                            className="w-full px-4 py-3 rounded-lg bg-white/10 border border-white/20 placeholder-gray-400 focus:outline-none"
                            onChange={(e) => setEmail(e.target.value)}
                            required
                        />

                        <input
                            type="tel"
                            placeholder="Phone Number"
                            value={phone}
                            onChange={(e) => setPhone(e.target.value)}
                            className="w-full px-4 py-3 rounded-lg bg-white/10 border border-white/20 placeholder-gray-400 focus:outline-none"
                            required
                        />

                        <button
                            type="submit"
                            className="w-full py-3 bg-green-600 rounded-lg font-bold hover:bg-green-700"
                        >
                            REQUEST CALLBACK
                        </button>

                    </form>
                </div>

            </div>

            {/* WhatsApp Floating Button */}
            {/* <div className="fixed bottom-6 right-6 bg-green-500 p-4 rounded-full shadow-lg cursor-pointer hover:bg-green-600">
        <FaWhatsapp size={24} />
      </div> */}

        </div>
    );
};

export default HeroSection;